class CustomTab extends HTMLElement {
  constructor() {
    super()
  }

  connectedCallback() {
    this.triggers.forEach((trigger) => {
      trigger.addEventListener("click", this.onTriggerClick.bind(this))
    })
    this.modals.forEach((modal) => {
      modal.classList.remove("hidden")
      modal.addEventListener("click", () => {
        if (!event.target.closest(".js-modal-content")) this.closeModal(event)
      })
    })
    this.modalCloses.forEach((closeTrigger) => {
      closeTrigger.addEventListener("click", this.closeModal.bind(this))
    })
  }

  onTriggerClick(event) {
    const index = event.currentTarget.getAttribute("data-index")
    const targetItem = this.querySelector(`.js-tab-content[data-index="${index}"]`)
    if (targetItem) {
      this.contents.forEach((content) => {
        if (content == targetItem) {
          content.classList.add("active")
        } else {
          content.classList.remove("active")
        }
      })

      this.triggers.forEach((trigger) => {
        const triggerIndex = trigger.getAttribute("data-index")
        if (triggerIndex == index) {
          trigger.classList.add("active")
        } else {
          trigger.classList.remove("active")
        }
      })

      if (event.currentTarget.getAttribute("data-type") == "modal") {
        const targetModal = document.querySelector(`.js-modal[data-index="${index}"]`)
        targetModal.classList.add("active")
        document.body.classList.add("overflow-hidden")
      }
    }
  }

  closeModal(e) {
    e.preventDefault()
    const modal = e.target.closest(".js-modal")
    modal.classList.remove("active")
    document.body.classList.remove("overflow-hidden")
  }

  get modals() {
    return this.querySelectorAll(".js-modal")
  }

  get modalCloses() {
    return this.querySelectorAll(".js-modal-close")
  }

  get contents() {
    return this.querySelectorAll(".js-tab-content")
  }

  get triggers() {
    return this.querySelectorAll(".js-tab-trigger")
  }
}

customElements.define("custom-tab", CustomTab)
